import { IconProps } from "./types";

export const EditIcon: React.FC<IconProps> = ({ fillColor }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path d="M14 12H0V13H14V12Z" fill={fillColor ?? "#333333"} />
      <path
        d="M11.7 3.5C12.1 3.1 12.1 2.5 11.7 2.1L9.9 0.3C9.5 -0.1 8.9 -0.1 8.5 0.3L1 7.8V11H4.2L11.7 3.5ZM9.2 1L11 2.8L9.5 4.3L7.7 2.5L9.2 1ZM2 10V8.2L7 3.2L8.8 5L3.8 10H2Z"
        fill={fillColor ?? "#333333"}
      />
    </svg>
  );
};
